import { AxiosInstance } from 'axios';
import { CreateSubscriptionDto } from '@jaam/commons/dtos';
import { AppErrorResponse, AUTH_API } from '../services/axios';
import { createSubscriptionService } from '../services/subscription';
import { useAppMutation } from './useAppMutation';

export function useCreateSubscription(
  options: {
    api?: AxiosInstance;
    onSuccess?: () => void;
    onError?: (error: AppErrorResponse) => void;
  } = {}
) {
  const { api, onSuccess, onError } = options;
  const apiInstance = api ?? AUTH_API;
  const subscriptionService = createSubscriptionService(apiInstance);

  const {
    mutate: createSubscription,
    isPending: isCreating,
    error: createError,
  } = useAppMutation<
    Awaited<ReturnType<typeof subscriptionService.create>>['data'],
    CreateSubscriptionDto
  >({
    mutationFn: (dto: CreateSubscriptionDto) =>
      subscriptionService.create(dto).then((r) => r.data),
    onSuccess: () => onSuccess?.(),
    onError,
  });

  return { createSubscription, isCreating, createError };
}
